"use client";

// 404 — mirrors Flutter not_found_screen.dart: app name, broken-link icon,
// "Invalid Link" message, and a button back to "/".

import Link from "next/link";
import { useT } from "@/lib/i18n/useT";
import { electionTitle } from "@/lib/branding";

export default function NotFound() {
  const t = useT();
  return (
    <main className="flex flex-1 flex-col items-center justify-center px-6 text-center">
      <h1 className="text-2xl font-semibold tracking-tight text-foreground">
        {electionTitle(t)}
      </h1>

      {/* broken-link icon */}
      <svg
        className="mt-8 h-16 w-16 text-muted"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M9 17H7A5 5 0 0 1 7 7h2" />
        <path d="M15 7h2a5 5 0 0 1 4 8" />
        <line x1="3" y1="3" x2="21" y2="21" />
      </svg>

      <h2 className="mt-6 text-lg font-medium text-foreground">Invalid Link</h2>
      <p className="mt-2 max-w-sm text-sm text-muted">
        Please use the link from your invitation to access the voting app.
      </p>

      <Link
        href="/"
        className="mt-8 inline-flex items-center justify-center rounded-2xl bg-primary px-6 py-3 text-sm font-medium text-primary-foreground shadow-sm transition-colors hover:bg-primary-hover"
      >
        {electionTitle(t)}
      </Link>
    </main>
  );
}
